import $ from 'jquery';
import React, { useContext, useEffect, useState } from 'react';
import Scrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { Link } from 'react-router-dom';
import ConnUrls from '../../MyConns/Connections/ConnectURL';
import utilsMaster from '../../MyConns/_Utils/utilsMaster';
import utilsSinglePage from '../../MyConns/_Utils/utilsSinglePage';
import myFunctions from '../../myFunctions';
import { TheMasterContext } from '../MyContexts/Master_Context';
import { SectionsContext } from '../MyContexts/Sections_Context';
import { UserContext } from '../MyContexts/Users_Context';

import utilsContactPage from '../../MyConns/_Utils/utilsContactPage';


const Sidenavigation = (props) => {

    const [user, setUser] = useContext(UserContext);
    const [theMaster, setTheMaster] = useContext(TheMasterContext);
    const [Sections, setSections] = useContext(SectionsContext);

    const [lstSimpePages, setLstSimpePages] = useState([]);
    const [lstContactpages, setLstContactpages] = useState([]);


    const [showPageSectionsList, setShowPageSectionsList] = useState(false);

    const [showSpagesList, setShowSpagesList] = useState(false);
    const [showContactsList, setShowContactsList] = useState(false);





    useEffect(() => {

        getCheck();
    })

    useEffect(() => {

        checkForMaster();
        getSimplePages();
        getConatctPages();
        setActiveMenuItem();

    }, [])


    const getCheck = async () => {
        let takeBak = await myFunctions.connCheck();
    }


    const checkForMaster = async () => {
        if (theMaster.length == 0) {
            let mast = await utilsMaster.getMaster();
            setTheMaster(mast)
        }
    }
    const getSimplePages = async () => {
        let tempo = await utilsSinglePage.allPgsNames();
        setLstSimpePages(tempo)

    }
    const getConatctPages = async () => {
        let tempo = await utilsContactPage.allPgsNames();
        setLstContactpages(tempo)

    }


    const setActiveMenuItem = () => {

        $('.ms-main-aside .menu-item>a').on('click', function () {
            $(this).removeAttr('href');
            var element = $(this).parent('li');
            if (element.hasClass('active')) {
                element.removeClass('active');
                element.find('li').removeClass('active');
                element.find('.collapse').slideUp();
            } else {
                element.addClass('active');
                element.children('.collapse').slideDown();
                element.siblings('li').children('.collapse').slideUp();
                element.siblings('li').removeClass('active');
                element.siblings('li').find('li').removeClass('active');
                element.siblings('li').find('.collapse').slideUp();
            }
        });
    }

    const removeoverlay = () => {
        $('.ms-body').toggleClass('ms-aside-left-open');
        $('#ms-side-nav').toggleClass('ms-aside-open');
        $(".ms-aside-overlay.ms-overlay-left").toggleClass('d-block');
    }

    return (
        <div>
            <div className="ms-aside-overlay ms-overlay-left ms-toggler" onClick={() => removeoverlay()}></div>
            <div className="ms-aside-overlay ms-overlay-right ms-toggler"></div>
            <Scrollbar id="ms-side-nav" className="side-nav fixed ms-aside-scrollable ms-aside-left">
                {/* Logo */}
                <div className="logo-sn ms-d-block-lg">
                    <Link className="pl-0 ml-0 text-center" to="/">
                        <img src={ConnUrls.servMediasUrl + theMaster.manageSiteLogo} alt="logo" />
                    </Link>
                </div>
                {/* Navigation */}

                <ul className="accordion ms-main-aside fs-14" id="side-nav-accordion">
                    {
                        (user.permiss != "admin") ?
                            <>
                                {/* Tbales Orders */}
                                {/* <li className={`menu-item ${window.location.href.includes('/TblOrders') || window.location.href.endsWith("/") ? "activeLnk" : ""}`} >
                                    <Link to="/TblOrders"> <span><i className="fa fa-credit-card fs-16" />הזמנת שולחנות</span>
                                    </Link>
                                </li> */}
                                {/* Orders */}
                                <li className={`menu-item ${window.location.href.includes('/Orders') ? "activeLnk" : ""}`} >
                                    <Link to="/Orders"> <span><i className="fa fa-credit-card fs-16" />הזמנות</span>
                                    </Link>
                                </li>
                                {/* Users */}
                                <li className={`menu-item ${window.location.href.includes('/Users') ? "activeLnk" : ""}`} >
                                    <Link to="/Users"> <span><i className="fa fa-user fs-16" />משתמשים</span>
                                    </Link>
                                </li>
                            </> : ""
                    }



                    {(user.permiss == "admin") ?
                        <>
                           <li className={`menu-item ${window.location.href.includes('/Orders') || window.location.pathname === '/' ? "activeLnk" : ""}`} >

                                <Link to="/Orders"> <span><i className="fa fa-credit-card fs-16" />הזמנות</span>
                                </Link>
                            </li>
                            {/* Master */}
                            < li className={`menu-item ${window.location.href.includes('/Master') ? "activeLnk" : ""}`} >
                                <Link to="/Master"> <span><i className="fa fa-archive fs-16" />Master</span>
                                </Link>
                            </li>
                            < li className={`menu-item ${window.location.href.includes('/HomeP') ? "activeLnk" : ""}`} >
                                <Link to="/HomeP"> <span><i className="fa fa-home fs-16" />עמוד הבית</span>
                                </Link>
                            </li>
                            {/* PageSections */}
                            {/* <li className="menu-item">
                                <div className={"spacMnuItm has-chevron pointing"} onClick={() => setShowPageSectionsList(!showPageSectionsList)}>
                                    <span><i className="fa fa-home fs-16" />מקטעים</span>
                                </div>
                                <ul id={"SpagesList"} className={(showPageSectionsList) ? "" : "collapse"} aria-labelledby="Sections" data-parent="#side-nav-accordion">
                                    <li key={"nswPSect"}> <Link to={"/nswPSec"} >מקטע חדש</Link>
                                    </li>

                                    {Sections?.map((item, index) => {
                                        let actLnk = window.location.href.includes(item.inLinkToPage) ? "activeLnk" : ""

                                        if (actLnk == "activeLnk" && !showPageSectionsList) {
                                            setShowPageSectionsList(true)
                                        }


                                        return (
                                            <li key={index} className={actLnk}>
                                                <Link to={item.inLinkToPage}>
                                                    <span>
                                                        <i className="fa fa-align-justify fs-16" />
                                                        {item.pageName}
                                                    </span>
                                                </Link>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </li> */}
                            {/* Tbales Orders */}
                            {/* <li className={`menu-item ${window.location.href.includes('/TblOrders') || window.location.href.endsWith("/") ? "activeLnk" : ""}`} >
                                <Link to="/TblOrders"> <span><i className="fa fa-credit-card fs-16" />הזמנת שולחנות</span>
                                </Link>
                            </li> */}
                            {/* Orders */}

                            {/* MenuP */}
                            <li className={`menu-item ${window.location.href.includes('/Menu') ? "activeLnk" : ""}`} >
                                <Link to="/Menu"> <span><i className="fa fa-utensils fs-16" />תפריט</span>
                                </Link>
                            </li>
                            {/* SimplePages */}
                            <li className="menu-item">
                                <div className={"spacMnuItm has-chevron pointing"} onClick={() => setShowSpagesList(!showSpagesList)}> <span><i className="fas fa-folder fs-16" />עמודים</span>
                                </div>
                                <ul id={"SpagesList"} className={(showSpagesList) ? "" : "collapse"} aria-labelledby="עמודים" data-parent="#side-nav-accordion">
                                    <li key={"newSp"}> <Link to={"/nswSp"} >עמוד חדש</Link>
                                    </li>

                                    {lstSimpePages?.map((item, index) => {
                                        return (
                                            <li key={index}> <Link to={item.inLinkToPage}>
                                                <span>
                                                    <i className="fa fa-align-justify fs-16" />
                                                    {item.pageName}
                                                </span>
                                            </Link>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </li>

                            {/* Contactpages */}
                            <li className="menu-item">
                                <div className={"spacMnuItm has-chevron pointing"} onClick={() => setShowContactsList(!showContactsList)}> <span><i className="fas fa-folder fs-16" />עמודי יצירת קשר</span>
                                </div>
                                <ul className={(showContactsList) ? "" : "collapse"} aria-labelledby="עמודי יצירת קשר" data-parent="#side-nav-accordion">
                                    <li key={"nswCP"}> <Link to={"/nswContP"} >עמוד חדש</Link>
                                    </li>

                                    {lstContactpages?.map((item, index) => {
                                        return (
                                            <li key={index}> <Link to={item.inLinkToPage}>
                                                <span>
                                                    <i className="fa fa-align-justify fs-16" />
                                                    {item.pageName}
                                                </span>
                                            </Link>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </li >
                            {/* Users */}
                            <li className={`menu-item ${window.location.href.includes('/Users') ? "activeLnk" : ""}`} >
                                <Link to="/Users"> <span><i className="fa fa-user fs-16" />משתמשים</span>
                                </Link>
                            </li>
                            <li className={`menu-item ${window.location.href.includes('/Users') ? "activeLnk" : ""}`} >
                                <Link to="/ClientUsers"> <span><i className="fa fa-user fs-16" />לקוחות</span>
                                </Link>
                            </li>
                            
                            {/* Managment */}
                            <li className={`menu-item ${window.location.href.includes('/Manage') ? "activeLnk" : ""}`} >
                                <Link to="/Manage"> <span><i className="fa fa-snowflake fs-16" />הגדרות</span>
                                </Link>
                            </li>

                            <li className={`menu-item ${window.location.href.includes('/ImageGall') ? "activeLnk" : ""}`} >
                                <Link to="/ImageGall"> <span><i className="fa fa-file-image fs-16" />מדיה</span>
                                </Link>
                            </li>

                        </> : ""}
                </ul>
            </Scrollbar >
        </div >
    );
}

export default Sidenavigation;